<template>
  <div>
    <v-row align="center" class="pa-4">
      <v-card-title>Журнал открытия</v-card-title>
      <div class="ml-2">
        <BaseTextField
          v-model="filterApartment"
          :is-button="false"
          :is-switch="true"
          icon="mdi-magnify"
          label="Введите номер квартиры"
        />
      </div>
      <div class="ml-2">
        <BaseTextField
          v-model="filterNumberCar"
          :is-button="false"
          :is-switch="true"
          icon="mdi-magnify"
          label="Введите номер автомобиля"
        />
      </div>
      <div class="ml-2">
        <BaseTextField
          v-model="filterPhone"
          :is-button="false"
          :is-switch="true"
          icon="mdi-magnify"
          label="Введите номер телефона"
        />
      </div>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer mt-1 mb-2"
            v-bind="attrs"
            v-on="on"
            @click="updateInfo"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-reload</v-icon>
          </v-btn>
        </template>
        <span>Обновить</span>
      </v-tooltip>
    </v-row>
    <v-data-table
      class="table"
      :headers="mobileHeadersJournal"
      :items="filtered"
      :footer-props="{
        'items-per-page-options': [10, 15, 20, 50],
        showFirstLastPage: true
      }"
    >
      <template v-slot:item.opening_source="{ item }">
        <span v-if="item.opening_source === 'app'">Через приложение</span>
        <span v-else-if="item.opening_source === 'call'">Через звонок</span>
        <span v-else>{{ item.opening_source || '-' }}</span>
      </template>
      <template v-slot:item.is_successful="{ item }">
        <v-chip
          :color="item.is_successful ? 'success' : 'error'"
          small
          dark
        >
          {{ item.is_successful ? 'Успешно' : 'Неуспешно' }}
        </v-chip>
      </template>
      <template v-slot:item.abonent\.apartment="{ item }">
        <span v-if="item.opening_source === 'app' && item.abonent && item.abonent.apartment">
          {{ item.abonent.apartment }}
        </span>
      </template>
      <template v-slot:item.carNumber="{ item }">
        <span v-if="item.opening_source === 'app' && item.abonent && item.abonent.car_number">
          {{ item.abonent.car_number.join(', ') }}
        </span>
      </template>
      <template v-slot:item.createdAt="{ item }">
        {{ ruDateFormat(item.created_at) }}
      </template>
      <template v-slot:item.abonent\.telephone="{ item }">
        <div v-if="item.opening_source === 'app' && item.abonent">
          <router-link class="routerLink" :to="`/client/${item.abonent.clients[0].id}`">
            {{ formatPhoneNumber(item.abonent.telephone) }}
          </router-link>
        </div>
        <div v-else-if="item.opening_source === 'call' && item.phone_number">
          {{ formatPhoneNumber(item.phone_number) }}
        </div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import BaseTextField from '../../../BaseTextField';
import formatPhoneNumber from '../../../../mixins/formatPhoneNumber';

export default {
  name: 'MobileBarrierOpening',
  components: { BaseTextField },
  props: ['id'],
  mixins: [ruDateFormatMixin, formatPhoneNumber],
  data () {
    return {
      options: {
        page: 1,
        itemsPerPage: 1000,
      },
      filterApartment: '',
      filterNumberCar: '',
      filterPhone: '',
      filters: { barrier_id: this.$route.params.id },
      sort: '',
      response: [],
      pagination: 1,
      mobileHeadersJournal: [
        { text: 'id', value: 'id', align: 'center' },
        { text: 'Источник', value: 'opening_source', align: 'center' },
        { text: 'Статус', value: 'is_successful', sortable: false, align: 'center' },
        { text: 'абонент', value: 'abonent.telephone', sortable: false, align: 'center' },
        { text: 'Квартира', value: 'abonent.apartment', sortable: false, align: 'center' },
        { text: 'Номер автомобиля', value: 'carNumber', sortable: false, align: 'center' },
        { text: 'дата и время', value: 'createdAt', sortable: false, align: 'center' },
      ],
      include: ['abonent.clients'],
    };
  },
  created () {
    this.loadBarrierOpeningMobile();
  },
  computed: {
    ...mapGetters({
      barrierOpeningMobiles: 'DoorOpenning/barrierOpeningMobiles',
    }),
    filtered () {
      const apartmentQuery = String(this.filterApartment || '').trim().toLowerCase();
      const carQuery = String(this.filterNumberCar || '').trim().toLowerCase();
      const phoneQuery = String(this.filterPhone || '').replace(/\D/g, '');

      return this.barrierOpeningMobiles.filter((item) => {
        if (apartmentQuery) {
          const apartment = item.opening_source === 'app' && item.abonent
            ? String(item.abonent.apartment ?? '').toLowerCase()
            : '';
          if (!apartment.includes(apartmentQuery)) {
            return false;
          }
        }

        if (carQuery) {
          const carNumbers = item.opening_source === 'app' && item.abonent && Array.isArray(item.abonent.car_number)
            ? item.abonent.car_number
            : [];
          const hasCar = carNumbers.some(carNumber =>
            String(carNumber).toLowerCase().includes(carQuery),
          );
          if (!hasCar) {
            return false;
          }
        }

        if (phoneQuery) {
          const appPhone = item.opening_source === 'app' && item.abonent
            ? String(item.abonent.telephone ?? '').replace(/\D/g, '')
            : '';
          const callPhone = item.opening_source === 'call'
            ? String(item.phone_number ?? '').replace(/\D/g, '')
            : '';
          if (!appPhone.includes(phoneQuery) && !callPhone.includes(phoneQuery)) {
            return false;
          }
        }

        return true;
      });
    },
  },
  methods: {
    ...mapActions({
      getBarrierOpeningMobiles: 'DoorOpenning/getBarrierOpeningMobiles',
    }),
    async updateInfo () {
      await this.loadBarrierOpeningMobile()
        .then(() => {
          this.$flash_success('Таблица обновлена!');
        });
    },
    async loadBarrierOpeningMobile () {
      await this.getBarrierOpeningMobiles({
        pagination: this.pagination,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        include: this.include,
        filters: this.filters,
        sort: this.sort,
      })
        .catch((err) => {
          console.error(err);
          this.$flash_warning('Не удалось получить журнал открытия');
        });
    },
  },
};
</script>

<style lang="scss" scoped>

.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}
</style>
